import { Expose, Type } from 'class-transformer';
import { AddressDto } from './address.dto';
import { SocialMediaDto } from './social-media.dto';

export class UpdateUserResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'cognito_id' })
  cognitoId: string;
  @Expose({ name: 'email' })
  email: string;
  @Expose({ name: 'full_name' })
  fullName: string;
  @Expose({ name: 'phone' })
  phone: string;
  @Expose({ name: 'job_title' })
  jobTitle: string;
  @Expose({ name: 'image' })
  image: string;
  @Expose({ name: 'is_private' })
  isPrivate: boolean;
  @Expose({ name: 'print_code' })
  printCode: string;
  @Expose({ name: 'birthdate' })
  birthdate: string;
  @Expose({ name: 'company' })
  company: string;
  @Expose({ name: 'status' })
  status: string;
  @Expose({ name: 'role' })
  role: string;
  @Expose({ name: 'pay_per_print' })
  payPerPrint: string;
  @Expose({ name: 'company_admin' })
  companyAdmin: boolean;
  @Expose({ name: 'user_type' })
  userType: string;
  @Expose({ name: 'interests' })
  interests: string;
  @Expose({ name: 'bio' })
  bio: string;
  @Expose({ name: 'payment_details' })
  paymentDetails: string;
  @Expose({ name: 'language' })
  language: string;
  @Expose({ name: 'show_notification' })
  showNotification: boolean;
  @Expose({ name: 'guests' })
  guests: string;
  @Expose({ name: 'permission' })
  permission: string;
  @Expose({ name: 'token' })
  token: string;
  @Expose({ name: 'company_token' })
  companyToken: string;
  @Expose({ name: 'address' })
  @Type(() => AddressDto)
  address: AddressDto;
  @Expose({ name: 'social_media' })
  @Type(() => SocialMediaDto)
  socialMedia: SocialMediaDto;
}
